import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AppRoutingModule } from '../app.routing.module';
import { LeadModalComponent } from './lead-modal/lead-modal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrComponent } from './toastr/toastr.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { ClabeInfoModalComponent } from './clabe-info-modal/clabe-info-modal.component';
import { LandingsComponent } from './landings/landings.component';
import { BlogComponent } from './blog/blog.component';
import { AdsenseComponent } from './adsense/adsense.component';
import { DynamicContentContainerComponent } from './dynamic-content-container/dynamic-content-container.component';



@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    LeadModalComponent,
    ToastrComponent,
    ClabeInfoModalComponent,
    LandingsComponent,
    BlogComponent,
    AdsenseComponent,
    DynamicContentContainerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbToastModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    LeadModalComponent,
    ToastrComponent,
    ClabeInfoModalComponent,
    AdsenseComponent,
    DynamicContentContainerComponent
  ],
  providers: [
    ToastrComponent
  ]
})
export class ComponentsModule { }
